import { Autocomplete, Checkbox, FormControl, MenuItem, Select, TextareaAutosize, TextField } from "@mui/material";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { PiBagFill } from "react-icons/pi";
import Slider from "react-slick";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { useFetchGetAllProjectBasedUserNameListQuery, useFetchNotificationListQuery, useFetchLogDetailsQuery } from "../../../slice/logdetailSlice";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { createEntity, fetchEntityById, filterEntities, postResource, newFilterEntities } from "../../../apis/apiService";
import dayjs from "dayjs";
import { allowPositiveDecimals, parseDate, validateEndDate, validateStartDate } from "../../common/PreventValidate";
import { extractLetters, extractTextFromHTML } from "../../../utils/textUtils";
import { toast } from "react-toastify";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { ExpandMore } from "@mui/icons-material";
import Loader from "../Loader";
import { FaRegMessage } from "react-icons/fa6";
import { MdOutlineAttachFile } from "react-icons/md";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SubTaskTabs } from "../../ProjectModule/task/TaskDetail";
import { MilestoneTasklistDetailTabs } from "../../ProjectModule/milestones/MilestoneTasklistDetail";
import CommonDetailTimer from "../timer/CommonDetailTimer";
import TaskReminderPopup from "./TaskRemainderPopup";
import TaskRecurrence from "./TaskRecurrence";
import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { useTheme } from "../../../ThemeContext";


export const CommonTaskDetail = ({
  id,
  project_id,
  refetch,
  //   project_based_users,
  //   project_based_users_refetch,
  task_view,
  isLoading,
  task_activity_status,
  handleBoxClick,
  showPath,
  updatePath,
  istaskDetail,
  isMilestoneDetail,
  TaskListId,
  overriddenProjectName,
}) => {
  const { isDarkMode } = useTheme();
  //   const { id } = useParams();
  //   const { project_id } = useParams();
  // const project_id = localStorage.getItem("project_id");
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [showTimers, setShowTimers] = useState(false);
  const [loading, setLoading] = useState(false);
  const StatusOptions = useSelector((state) => state.selectOptions?.StatusOptions);
  const statusNames = StatusOptions.find((status) => status.status_type === "TASK");
  const status_list = statusNames?.status_details?.map((status) => ({
    status_id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));
  // console.log("stattus_options :", status_list);
  // console.log("stattus_options status names :", statusNames);

  const PriorityNameOptions = useSelector((state) => state.selectOptions?.PriorityNameOptions);
  // const { data: project_based_users, refetch: project_based_users_refetch } =
  //   useFetchGetAllProjectBasedUserNameListQuery(project_id);
  const {
    data: project_based_users,
    refetch: project_based_users_refetch,
    isUninitialized: isProjectUsersUninitialized,
    isLoading: isProjectUsersLoading,
  } = useFetchGetAllProjectBasedUserNameListQuery(project_id);
  // console.log("project_based_users :", project_based_users);
  const completedPercentage = [25, 50, 75, 100];
  const [headanchorEl, setheadAnchorEl] = useState(null);
  const [tasksDetail, settasksDetail] = useState([]);
  const [subtasklist, setSubtasklist] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  // const [fieldDescription, setFieldDescription] = useState("");
  // const { data: notification_list, refetch: notification_refetch } =
  //   useFetchNotificationListQuery();
    // const { data: notification_list, refetch: notification_refetch } =
  //   useFetchNotificationListQuery();
  const {
    refetch: notification_refetch,
    isUninitialized: isNotifUninitialized,
    isLoading: isNotifLoading,
  } = useFetchNotificationListQuery();

  const { data: logDetails } = useFetchLogDetailsQuery(id, { skip: !id });

  // Calculate total consumed hours and log hours dynamically
  let totalHoursSum = 0;
  if (logDetails && Array.isArray(logDetails)) {
    logDetails.forEach((log) => {
      if (log.logHourse && log.logHourse[0]) {
        const valStr = String(log.logHourse[0]);
        if (valStr.includes(":")) {
          const [h, m] = valStr.split(":").map(Number);
          totalHoursSum += (h || 0) + (m || 0) / 60;
        } 
        else {
          const val = parseFloat(valStr);
          if (!isNaN(val)) {
            totalHoursSum += val;
          }
        }
      }
    });
  }

  const calculatedConsumedHours = totalHoursSum.toFixed(2);

  const hrsInitial = Math.floor(totalHoursSum);
  let mins = Math.round((totalHoursSum - hrsInitial) * 60);
  let hrs = hrsInitial;
  if (mins === 60) {
    hrs += 1;
    mins = 0;
  }
  const calculatedTotalLogHours = `${String(hrs).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;

  const inputRef = useRef(null);
  useRef(null);
  const dueDateTimeoutRef = useRef(null);
  const [, setIsEditing] = useState(false);
  const [startDateError, setStartDateError] = useState("");
  const [dueDateError, setDueDateError] = useState("");
  const [taskTitle] = useState(tasksDetail.title);
  const [nameChange, setNameChange] = useState({
    owner_id: null,
    current_status_id: null,
    priority_id: null,
    description: "",
    start_date: null,
    consumed_hours: 0,
    completed_percentage: "",
    end_date: null,
    estimated_hours: 0,
    title: "",
    billing_type: null,
  });
  const tasklist_id = tasksDetail?.task_list_id;
  // console.log("Task_list_id: ", tasklist_id);

  const navigate = useNavigate();
  const location = useLocation();

  const usersInProjects = useSelector(
    (state) => state.selectOptions?.UserNameOptions
  );
  // console.log("owner_details name :", usersInProjects);

  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  // console.log("login_user_detail in redux state: ", loginUser);
  const { name, id: login_user_id, role: login_user_role } = loginUser;

  const { control } = useForm();
  // const handleBackClick = () => {
  //   navigate(-1);
  // };
  
    const handleBackClick = () => {
    // Re-check for back button to avoid history loops
    if (location.state?.from) {
      navigate(-1);
    } else if (istaskDetail) {
      navigate(`/projects/projectDetail/${project_id}/tasks`);
    } else {
      navigate(-1);
    }
  };

  const handleClick = (event) => {
    setheadAnchorEl(event.currentTarget);
  };
  const HeadhandleClose = () => {
    setheadAnchorEl(null); // Ensure this sets the anchor element to null to close the menu
  };

  useEffect(() => {
    if (task_view) {
      localStorage.setItem("billing_type", task_view.billing_type);
      // console.log("task_detail_response :", task_view.task_list_id);

      settasksDetail(task_view); // Use `task_view` directly instead of `fetchtasksDetail`
    }
  }, [id, task_view]); // Depend on `task_view` instead of `id`

  const allTasks = useMemo(() => {
    if (istaskDetail) {
      return subtasklist?.flatMap((taskGroup) =>
        Array.isArray(taskGroup.tasks) ? taskGroup.tasks : []
      ) || [];
    } else {
      return subtasklist || [];
    }
  }, [subtasklist, istaskDetail]);

  const sliderRef = useRef(null);

  useEffect(() => {
    if (sliderRef.current && allTasks?.length > 0 && tasksDetail?.task_id) {
      const activeIndex = allTasks.findIndex(
        (task) => task.task_id === tasksDetail.task_id
      );

      if (activeIndex !== -1) {
        sliderRef.current.slickGoTo(activeIndex);
      }
    }
  }, [allTasks, tasksDetail?.task_id]);

  const settings = {
    dots: false,
    infinite: true, // Ensure infinite scrolling is enabled
    slidesToShow: allTasks.length > 0 ? Math.min(5, allTasks.length) : 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,

    beforeChange: function (currentSlide, nextSlide) {
      // console.log("Before change", currentSlide, nextSlide);
    },
    afterChange: function (currentSlide) {
      // console.log("After change", currentSlide);
    },
  };

  useEffect(() => {
    if (tasksDetail?.description !== undefined) {
      setNameChange((prev) => ({
        ...prev,
        description: extractTextFromHTML(tasksDetail.description || ""),
      }));
    }
  }, [tasksDetail?.description, setNameChange]);

  const handlePrevClick = () => {
    if (
      sliderRef.current &&
      typeof sliderRef.current.slickPrev === "function"
    ) {
      sliderRef.current.slickPrev();
    } 
    else {
      console.warn("Slick slider is not ready yet");
    }
  };

  const handleNextClick = () => {
    if (
      sliderRef.current &&
      typeof sliderRef.current.slickNext === "function"
    ) {
      sliderRef.current.slickNext();
    } 
    else {
      console.warn("Slick slider is not ready yet");
    }
  };

  // Find current task index
  const currentIndex = allTasks?.findIndex(
    (task) => task.task_id.toString() === id
  );
  const handlePrevTaskNav = () => {
    if (currentIndex > 0) {
      const prevTaskId = allTasks[currentIndex - 1]?.task_id;
      navigate(`/projects/projectDetail/${project_id}/taskdetail/${prevTaskId}`);
    }
  };

  const handleNextTaskNav = () => {
    if (currentIndex < allTasks.length - 1) {
      const nextTaskId = allTasks[currentIndex + 1]?.task_id;
      navigate(`/projects/projectDetail/${project_id}/taskdetail/${nextTaskId}`);
    }
  };

  const fetchSubtasklist = async () => {
    try {
      let response;
      if (istaskDetail) {
        // Read the saved filter value from localStorage to match the Tasks table view
        let filterVal = 1; // Default to 'All Tasks'
        try {
          const stored = localStorage.getItem(`projectTaskFilter_${project_id}`);
          if (stored !== null) {
            filterVal = JSON.parse(stored);
          }
        } 
        catch (e) {
          console.error("Failed to parse projectTaskFilter from localStorage", e);
        }

        // Use newFilterEntities to pass view_type_id as a query param
        response = await newFilterEntities(showPath, project_id, {
          view_type_id: filterVal,
        });
      } 
      else {
        response = await fetchEntityById(showPath, TaskListId);
      }
      setSubtasklist(response.data);
    } 
    catch (err) {
      // Show error in toast
      toast.error(err.message || "Failed to fetch subtasks");
    }
  };

  useEffect(() => {
    fetchSubtasklist();
    if (typeof project_based_users_refetch === "function" && !isProjectUsersUninitialized && !isProjectUsersLoading) {
      try {
        project_based_users_refetch();
      } catch (e) {
        console.debug("Safe refetch guard handled early call in CommonTaskDetail");
      }
    }
  }, [id, project_id, isProjectUsersUninitialized, isProjectUsersLoading, project_based_users_refetch]);

  useEffect(() => {
    if (typeof project_based_users_refetch === "function" && !isProjectUsersUninitialized && !isProjectUsersLoading) {
      try {
        project_based_users_refetch();
      } 
      catch (e) {
        console.debug("Safe refetch guard handled early call in CommonTaskDetail state change");
      }
    }
  }, [isProjectUsersUninitialized, isProjectUsersLoading, project_based_users_refetch]);

  // Persistent active tab listener and restore logic for SubTaskTabs / MilestoneTasklistDetailTabs
  useEffect(() => {
    const handleTabShow = (event) => {
      const targetTabId = event.target.getAttribute("aria-controls");
      const taskTabs = ["Comments", "Subtasks", "LogHours", "Documents", "Issues", "ActivityStream", "taskbudget", "Board", "Status"];
      if (targetTabId && taskTabs.includes(targetTabId)) {
        const key = istaskDetail ? "taskActiveTab" : "milestoneActiveTab";
        sessionStorage.setItem(key, targetTabId);
      }
    };

    document.addEventListener("shown.bs.tab", handleTabShow);
    return () => { document.removeEventListener("shown.bs.tab", handleTabShow);};
  }, [istaskDetail]);

  useEffect(() => {
    const key = istaskDetail ? "taskActiveTab" : "milestoneActiveTab";
    const savedTab = sessionStorage.getItem(key);
    if (savedTab) {
      const clickTab = () => {
        const tabEl = document.getElementById(`${savedTab}-tab`);
        if (tabEl) {
          tabEl.click();
        }
      };

      clickTab();
      const t1 = setTimeout(clickTab, 100);
      const t2 = setTimeout(clickTab, 300);
      const t3 = setTimeout(clickTab, 600);

      return () => {
        clearTimeout(t1);
        clearTimeout(t2);
        clearTimeout(t3);
      };
    }
  }, [id, tasksDetail, istaskDetail]);

  useEffect(() => {
    // console.log("task_detail_owner :", tasksDetail);

    // Ensure owners exist and extract user IDs
    const owner_list =
      tasksDetail?.owners?.map((user) => {
        // console.log("task_detail_owner list :", user.name);
        return user.user_id; // Extract user IDs correctly
      }) || [];

    // console.log("task_detail_owner owner_list list :", owner_list);

    if (tasksDetail) {
      setNameChange({
        owner_id: owner_list, // Assign extracted user IDs
        current_status_id: tasksDetail.current_status_id || null,
        priority_id: tasksDetail.priority_id || null,
        description: extractTextFromHTML(tasksDetail.description || ""),
        start_date: tasksDetail.start_date || null,
        consumed_hours: tasksDetail.consumed_hours || 0,
        completed_percentage: tasksDetail.completed_percentage || "",
        end_date: tasksDetail.end_date || null,
        estimated_hours: tasksDetail.estimated_hours || 0,
        title: tasksDetail.title || "",
        billing_type: tasksDetail.billing_type || null,
      });
    }
  }, [id, task_view, tasksDetail]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNameChange((prev) => {
      const updated = { ...prev, [name]: value };
      //   console.log(" Task_ID_value Updated field:", name, "Value:", value);
      // console.log("  Task_ID_value Updated state:", updated);
      return updated;
    });
  };
  const task_id = tasksDetail?.task_id;
  // console.log("task_is changed:", task_id);

  // const extractHtmlDescription = extractTextFromHTML(nameChange.description);
  // console.log("extracted_description :", nameChange);
  // console.log("extracted_description name change :", nameChange.description);
  const handleBlur = async (e, taskId, ownerName) => {
    const { name, value } = e.target;
    // console.log("autocomplete_name :", name, value);
    setIsEditing(false);
    setLoading(true);
    // console.log(
    // ` handle_blur_val  Task ID: ${taskId}, Field: ${name}, Value: ${value}, Owner: ${ownerName}`
    // );

    const finalValue = (name === "description" && value.trim() === "") ? " " : value;
    const requestedData = {
      [name]: finalValue,
      // owner: ownerName, // Ensure the owner name is passed
    };

    // console.log("Requested data for update: ", requestedData);

    try {
      const response = await postResource( updatePath, "update", task_id, requestedData);
      // console.log("Update Response: ", response);
      // fetchtasksDetail();
      if (response) {
        toast.success(response.message);
        task_activity_status();

        // notification_refetch(); // Old unguarded call - replaced with safe guard below
        if (typeof notification_refetch === "function" && !isNotifUninitialized && !isNotifLoading) {
          try {
            notification_refetch();
          } 
          catch (e) {
            console.debug("Safe refetch guard handled early call for notification_refetch in CommonTaskDetail");
          }
        }
        fetchSubtasklist();
        if (refetch && typeof refetch === "function") {
          await refetch();
        }
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!subtasklist) return;
    // Find the first matching task and update the state once
    const matchedTask = subtasklist
      .flatMap((taskList) => taskList.tasks || [])
      .find((task) => task.task_id === tasksDetail?.task_id);

    if (matchedTask) {
      setSelectedUser(matchedTask.added_by);
    }
  }, [subtasklist, tasksDetail]);

  // // console.log("task_detail_response :", tasksDetail);
  // // console.log("owner_id_list :", task_view?.owner, name);
  // console.log("owner_id_list subtasklist :", subtasklist);
  // console.log("owner_id_list  task detail:", tasksDetail);

  const handleInputBlur = (e) => {
    setIsEditing(false);
    handleBlur(e, tasksDetail.task_id, taskTitle); // Pass updated task name
  };

  const handleEditClick = () => {
    setIsEditing(true);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  useEffect(() => {
    const isDisabled =
      !["ADMIN", "MANAGER", "CLIENT"].includes(login_user_role) &&
      !task_view?.owners?.some((owner) => owner.user_id === login_user_id) &&                                 
      selectedUser !== login_user_id &&
      task_view?.owners?.length > 0 &&
      task_view?.owners?.every(
        (owner) => owner.name === "Unassigned" || owner.name === null
      ) === false;

    setFieldsDisabled(isDisabled);
  }, [login_user_role, task_view, selectedUser]);

  // timers

  const [showPauseModal, setShowPauseModal] = useState(false);
  // const [showStopModal, setShowStopModal] = useState(false);
  const [showStopModal, setShowStopModal] = useState(
    localStorage.getItem("showStopModalPending") === "true"
  );

  const [isPaused, setIsPaused] = useState(false);
  const [getTimers, setGetTimers] = useState([]);
  const [secondsElapsed, setSecondsElapsed] = useState(0);
  const intervalRef = useRef(null);
  const [getTimerId, setGetTimerId] = useState(
    localStorage.getItem("timer_id")
  );
  const [timerDatas, setTimerDatas] = useState();
  const formatTime = (totalSeconds) => {
    const hrs = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((totalSeconds % 3600) / 60)).padStart( 2, "0" );
    const secs = String(totalSeconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const getTimer = async () => {
    if (!id || id === "undefined" || !project_id || project_id === "undefined" || !login_user_id || ["EMPLOYEE"].includes(login_user_role)) return;
    try {
      const requestedData = {
        user_id: login_user_id,
        task_id: id,
        project_id: project_id,
        log_date: dayjs().format("YYYY-MM-DD"),
      };
      const getTimerResponse = await filterEntities("timer/get", requestedData);
      localStorage.setItem("timer_id", getTimerResponse.timer_id);
      setGetTimerId(getTimerResponse.timer_id);
      if (getTimerResponse?.running) {
        setSecondsElapsed(getTimerResponse.total_seconds || 0);
        setGetTimers(getTimerResponse);
        // setShowTimers(true);
        // setIsPaused(false);
      }
      if (getTimerResponse?.running && getTimerResponse?.status === "STARTED") {
        setShowTimers(true);
        setIsPaused(false);
      }
      if (!getTimerResponse?.running && getTimerResponse?.status === "PAUSED") {
        setIsPaused(true);
        setShowTimers(true);
      }
      if (!getTimerResponse?.running && getTimerResponse?.status == null) {
        // setIsPaused(true);
        setShowTimers(false);
      }
    } catch (err) {
      if (login_user_role !== "CLIENT") {
        toast.error(err.message);
      }
    }
  };

  useEffect(() => {
    if (id && id !== "undefined" && project_id && project_id !== "undefined" && !["EMPLOYEE"].includes(login_user_role)) {
      getTimer();
    }

    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, [id, project_id]);

  useEffect(() => {
    const stopModalPending =
      localStorage.getItem("showStopModalPending") === "true";
    const timerDataFromStorage = JSON.parse(localStorage.getItem("timer_data"));
    const storedTimerId = localStorage.getItem("timer_id");

    if (stopModalPending && timerDataFromStorage) {
      setTimerDatas(timerDataFromStorage);
      setShowStopModal(true);

      // ✅ Restore timer_id if not already set
      if (!getTimerId && storedTimerId) {
        setGetTimerId(storedTimerId);
      }
    }
  }, []);

  useEffect(() => {
    if (getTimers?.running && !isPaused) {
      intervalRef.current = setInterval(() => {
        setSecondsElapsed((prev) => prev + 1);
      }, 1000);
    }

    return () => clearInterval(intervalRef.current); // Clear on pause or stop
  }, [getTimers, isPaused, getTimer]);

  const handleStartTimer = async () => {
    const requestedData = {
      task_id: id,
      project_id: project_id,
      log_date: dayjs().format("YYYY-MM-DD"),
    };

    try {
      const response = await createEntity("timer/start", requestedData);
      if (response) {
        await getTimer();
        toast.success(response.message);
      }
    } 
    catch (err) {
      toast.error(err.message);
    }
  };

  const handlePauseClick = () => {
    setShowPauseModal(true);
  };

  const handleResumeTimer = async () => {
    const requestedData = {
      // user_id: login_user_id,
      // task_id: id,
      // project_id: project_id,
      // log_date: dayjs().format("YYYY-MM-DD"),
      timer_id: getTimerId,
      // notes: note,
    };

    try {
      const response = await createEntity("timer/resume", requestedData);
      if (response.data.status === "STARTED") {
        toast.success(response.message);
        // setIsPaused(false);
        // setShowTimers(true);
        await getTimer();
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleStopTimer = async () => {
    const requestedData = {
      timer_id: getTimerId,
    };
    try {
      const response = await createEntity("timer/stop", requestedData);
      toast.success(response.message);
      if (response) {
        // setTimerDatas(response.data);
        // localStorage.setItem("timer_data", JSON.stringify(response.data));
        // localStorage.setItem("showStopModalPending", "true");
        // setShowStopModal(true);
        // setTimerDatas(response.data);
        const timerData = response.data;
        localStorage.setItem("timer_data", JSON.stringify(timerData));
        localStorage.setItem("new_timer_id", timerData.timer_id);
        localStorage.setItem("showStopModalPending", "true");

        setTimerDatas(timerData);
        setShowStopModal(true);
      }
    } 
    catch (err) {
      toast.error(err.message);
    }
  };

  const handleUpdatePauseNote = async (note) => {
    const requestedData = {
      // user_id: login_user_id,
      // task_id: id,
      // project_id: project_id,
      // log_date: dayjs().format("YYYY-MM-DD"),
      timer_id: getTimerId,
      notes: note,
    };
    try {
      const response = await createEntity("timer/pause", requestedData);
      toast.success(response.message);
      if (response.data.status === "PAUSED") {
        setShowPauseModal(false);
        // setIsPaused(true);
        await getTimer();
        // setShowTimers(true);
      }
    } 
    catch (err) {
      toast.error(err.message);
    }
    // Pause timer logic here
  };
  
  return (
    <>
      {loading || isLoading ? (
        <Loader />
      ) : (
        <div>
          <div
            className="d-flex justify-content-between align-items-center bg-white mb-3 p-3 border-bottom rounded-bottom"
            style={{ position: "sticky", top: 0, zIndex: 100, boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)" }}
          >
            <div className="d-flex align-items-center gap-3">
              <button className="R_btn me-2" onClick={handleBackClick}>
                <IoIosArrowBack className="text-rgba-gray" size={17} />
              </button>
              
              <label className="text-rgba-gray m-0 d-flex align-items-center gap-1" style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
                <PiBagFill className="text-rgba-gray me-1" style={{ color: isDarkMode ? "#a0aec0" : undefined }} />
                Project Name: <span className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>{extractLetters(overriddenProjectName || tasksDetail?.project_title)}</span>
              </label>

              <span className="text-rgba-gray border-start ps-3 py-1" style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
                Task List Name: <span className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>{extractLetters(tasksDetail?.task_list_name)}</span>
              </span>

              <span className="text-rgba-gray border-start ps-3 py-1" style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
                Task Name: <span className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>{extractLetters(nameChange.title || tasksDetail?.title)}</span>
              </span>
            </div>
            
            <div className={`d-flex align-items-center border rounded-3 overflow-hidden ${isDarkMode ? "" : "bg-white"}`} style={{ borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#e5e7eb', backgroundColor: isDarkMode ? 'transparent' : undefined }}>
              <style>{`
                .header-icon-item {
                  cursor: pointer;
                  transition: background-color 0.2s ease;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  padding: 8px 16px;
                  text-decoration: none;
                }
                .header-icon-item:hover {
                  background-color: ${isDarkMode ? "rgba(255, 255, 255, 0.15)" : "#f3f4f6"};
                }
              `}</style>

              {/* Comments */}
              <div
                className="header-icon-item border-end"
                style={{ borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#e5e7eb' }}
                onClick={() => {
                  const tabEl = document.getElementById("Comments-tab");
                  if (tabEl) tabEl.click();
                }}
              >
                <FaRegMessage className="text-rgbr-blue me-1" />
                <span className="text-rgba-gray">
                  ({tasksDetail.comment_count || 0})
                </span>
              </div>

              {/* Documents */}
              <div
                className={`header-icon-item ${!fieldsDisabled ? 'border-end' : ''}`}
                style={{ borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.15)' : '#e5e7eb' }}
                onClick={() => {
                  const tabEl = document.getElementById("Documents-tab");
                  if (tabEl) tabEl.click();
                }}
              >
                <MdOutlineAttachFile className="text-rgbr-blue me-1" />
                <span className="text-rgba-gray">
                  ({tasksDetail.document_count || 0})
                </span>
              </div>

              {/* Timer */}
              {!fieldsDisabled && (
                <div className="header-icon-item">
                  <CommonDetailTimer
                    user_id={login_user_id}
                    task_id={id}
                    project_id={project_id}
                  />
                </div>
              )}
            </div>
            {/* <div className="d-flex align-items-center">
          <div className="ps-3">
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
            
              <BsThreeDots />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={headanchorEl}
              open={Boolean(headanchorEl)}
              onClose={HeadhandleClose}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  width: "20ch",
                },
              }}
            >
              <MenuItem>Edit</MenuItem>
              <MenuItem>Delete</MenuItem>
              <MenuItem>Clone</MenuItem>
              <MenuItem>Copy Link</MenuItem>
            </Menu>
          </div>
        </div> */}
          </div>
          <div className="container-fluid overflow-x-hidden">
            <div className="row bg-white p-3">
              <div className="col-md-9">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <form className="pe-5">
                    {/* {[tasksDetail]?.map((task, index) => ( */}
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <label
                          htmlFor="project_manager_id"
                          className="form-label"
                        >
                          Owner
                        </label>
                        <FormControl fullWidth>
                          <Autocomplete
                            multiple
                            options={project_based_users || []}
                            getOptionLabel={(option) => option.name}
                            value={
                              project_based_users?.filter((user) =>
                                nameChange.owner_id?.includes(user.user_id)
                              ) || []
                            } // Map user objects based on selected IDs
                            isOptionEqualToValue={(option, value) =>
                              option.user_id === value.user_id
                            }
                            onChange={(event, newValue) => {
                              // Extract user IDs from selected values
                              const selectedIds = newValue.map(
                                (user) => user.user_id
                              );
                              setNameChange((prev) => ({
                                ...prev,
                                owner_id: selectedIds,
                              }));

                              // Create a synthetic event-like object
                              const fakeEvent = {
                                target: {
                                  name: "owners",
                                  value: selectedIds,
                                },
                              };

                              // Call handleBlur with the synthetic event
                              handleBlur(fakeEvent, task_view?.task_id);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                // placeholder="Select Owners"
                              />
                            )}
                            renderOption={(props, option, { selected }) => (
                              <li
                                {...props}
                                className="d-flex align-items-center mb-2"
                              >
                                <Checkbox
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                <strong>{option.name}</strong>
                              </li>
                            )}
                            ListboxProps={{
                              style: {
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr",
                                gap: "8px",
                                paddingLeft: "0",
                              },
                            }}
                            // disabled={
                            //   !["ADMIN", "MANAGER"].includes(login_user_role) &&
                            //   selectedUser !== login_user_id &&
                            //   task_view?.owner !== name
                            // }
                            // disabled={
                            //   !["ADMIN", "MANAGER"].includes(login_user_role) &&
                            //   !task_view?.owners?.some(
                            //     (owner) => owner.user_id === login_user_id
                            //   ) &&
                            //   selectedUser !== login_user_id
                            // }
                            disabled={fieldsDisabled}
                          />
                        </FormControl>
                      </div>
                      <div className="col-md-4 pb-3">
                        <label
                          htmlFor="current_status_id"
                          className="form-label"
                        >
                          Status
                        </label>
                        <FormControl fullWidth>
                          <Select
                            name="current_status_id"
                            onBlur={(e) => handleBlur(e, task_view?.task_id)}
                            onChange={handleInputChange}
                            // {...field}
                            value={nameChange.current_status_id || "no value"}
                            IconComponent={ExpandMoreIcon}
                            displayEmpty
                            renderValue={(selected) => {
                              const selected_value = status_list?.find(
                                (status) => status.status_id === selected
                              );
                              // console.log("selected_value :", selected_value);

                              return selected_value ? (
                                <span
                                  style={{
                                    color: selected_value.status_colour,
                                  }}
                                >
                                  {selected_value.status_name}
                                </span>
                              ) : (
                                <span className=" lightText">
                                  Select status
                                </span>
                              );
                            }}
                            disabled={fieldsDisabled}
                          >
                            {status_list?.map((status) => (
                              <MenuItem
                                key={status.status_id}
                                value={status.status_id}
                                sx={{ color: status.status_colour || "black" }}
                              >
                                {status.status_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label
                          htmlFor="completed_percentage"
                          className="form-label"
                        >
                          Complete Percentage
                        </label>
                        <FormControl fullWidth>
                          <Select
                            name="completed_percentage"
                            value={nameChange.completed_percentage}
                            onChange={(event) => {
                              // preventNegativeValues(event);
                              handleInputChange(event);
                            }}
                            onBlur={(e) => handleBlur(e, task_view?.task_id)}
                            IconComponent={ExpandMore}
                            displayEmpty
                            // disabled={
                            //   !["ADMIN", "MANAGER"].includes(login_user_role) && // ✅ Allow Admin & Manager
                            //   selectedUser !== login_user_id &&
                            //   task_view?.owner !== name
                            // }
                            disabled={fieldsDisabled}
                            renderValue={(selected) =>
                              selected ? (
                                selected
                              ) : (
                                <span className=" lightText">Percentage</span>
                              )
                            }
                          >
                            {completedPercentage.map((option, index) => (
                              <MenuItem key={index} value={option}>
                                {option}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="start_date" className="form-label">
                          Start Date
                        </label>
                        <div className=" d-flex flex-column w-100">
                          <DatePicker
                            className="datepicker_input"
                            name="start_date"
                            // value={
                            //   nameChange.start_date
                            //     ? dayjs(nameChange.start_date)
                            //     : null
                            // }
                            value={parseDate(nameChange.start_date)}
                            format="DD/MM/YYYY"
                            disabled={fieldsDisabled}
                            onChange={(date) => {
                              const newDate = date ? dayjs(date) : null;

                              if (!newDate) {
                                setStartDateError("");
                                setNameChange((prev) => ({
                                  ...prev,
                                  start_date: null,
                                }));
                                handleBlur(
                                  {
                                    target: {
                                      name: "start_date",
                                      value: null,
                                    },
                                  },
                                  task_view?.task_id
                                );
                                return;
                              }

                              if (!newDate.isValid() || newDate.year() < 1990) {
                                setStartDateError("Invalid date format");
                                
                                if (newDate.isValid() && newDate.year() >= 1000 && newDate.year() < 1990) {
                                  const prevDate = tasksDetail.start_date || null;
                                  setNameChange((prev) => ({
                                    ...prev,
                                    start_date: prevDate,
                                  }));
                                  setStartDateError("");
                                  return;
                                }

                                setNameChange((prev) => ({
                                  ...prev,
                                  start_date: newDate,
                                }));
                                return;
                              }

                              if (!validateStartDate(newDate, nameChange.end_date)) {
                                return;
                              }

                              setStartDateError("");
                              setNameChange((prev) => ({
                                ...prev,
                                start_date: newDate,
                              }));
                              handleBlur(
                                {
                                  target: {
                                    name: "start_date",
                                    value: newDate.format("DD-MM-YYYY"),
                                  },
                                },
                                task_view?.task_id
                              );
                            }}
                            renderInput={(params) => {
                              const originalOnBlur = params.inputProps?.onBlur;
                              return (
                                <TextField
                                  className="form-control datepicker_input"
                                  {...params}
                                  inputProps={{
                                    ...params.inputProps,
                                    onBlur: (e) => {
                                      if (originalOnBlur) originalOnBlur(e);
                                      
                                      const val = nameChange.start_date;
                                      if (val) {
                                        const d = dayjs(val);
                                        if (!d.isValid() || d.year() < 1990) {
                                          const prevDate = tasksDetail.start_date || null;
                                          setNameChange((prev) => ({
                                            ...prev,
                                            start_date: prevDate,
                                          }));
                                        }
                                      }
                                      setStartDateError("");
                                    }
                                  }}
                                />
                              );
                            }}
                          />
                          {startDateError && (
                            <span className="errorMsg">
                              {startDateError}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div>
                          <label htmlFor="end_date" className="form-label">
                            Due Date
                          </label>
                          <div className="d-flex  flex-column w-100">
                            <DatePicker
                              className="datepicker_input"
                              name="end_date"
                              format="DD/MM/YYYY"
                              value={parseDate(nameChange.end_date)}
                              disabled={fieldsDisabled}
                              onChange={(date) => {
                                const newDate = date ? dayjs(date) : null;

                                if (dueDateTimeoutRef.current) {
                                  clearTimeout(dueDateTimeoutRef.current);
                                  dueDateTimeoutRef.current = null;
                                }

                                if (!newDate) {
                                  setDueDateError("");
                                  setNameChange((prev) => ({
                                    ...prev,
                                    end_date: null,
                                  }));
                                  handleBlur(
                                    {
                                      target: {
                                        name: "end_date",
                                        value: null,
                                      },
                                    },
                                    task_view?.task_id
                                  );
                                  return;
                                }

                                if (!newDate.isValid() || newDate.year() < 1990) {
                                  setDueDateError("Invalid date format");
                                  
                                  setNameChange((prev) => ({
                                    ...prev,
                                    end_date: newDate,
                                  }));

                                  if (newDate.isValid() && newDate.year() >= 1000 && newDate.year() < 1990) {
                                    dueDateTimeoutRef.current = setTimeout(() => {
                                      const prevDate = tasksDetail.end_date || null;
                                      setNameChange((prev) => ({
                                        ...prev,
                                        end_date: prevDate,
                                      }));
                                      setDueDateError("");
                                    }, 3000);
                                  }
                                  return;
                                }

                                if (!validateEndDate(nameChange.start_date, newDate)) {
                                  return;
                                }

                                setDueDateError("");
                                setNameChange((prev) => ({
                                  ...prev,
                                  end_date: newDate,
                                }));

                                handleBlur(
                                  {
                                    target: {
                                      name: "end_date",
                                      value: newDate.format("DD-MM-YYYY"),
                                    },
                                  },
                                  task_view?.task_id
                                );
                              }}
                              renderInput={(params) => {
                                const originalOnBlur = params.inputProps?.onBlur;
                                return (
                                  <TextField
                                    className="form-control datepicker_input"
                                    {...params}
                                    inputProps={{
                                      ...params.inputProps,
                                      onBlur: (e) => {
                                        if (originalOnBlur) originalOnBlur(e);
                                        
                                        if (dueDateTimeoutRef.current) {
                                          clearTimeout(dueDateTimeoutRef.current);
                                          dueDateTimeoutRef.current = null;
                                        }

                                        const val = nameChange.end_date;
                                        if (val) {
                                          const d = dayjs(val);
                                          if (!d.isValid() || d.year() < 1990) {
                                            const prevDate = tasksDetail.end_date || null;
                                            setNameChange((prev) => ({
                                              ...prev,
                                              end_date: prevDate,
                                            }));
                                          }
                                        }
                                        setDueDateError("");
                                      }
                                    }}
                                  />
                                );
                              }}
                            />
                            {dueDateError && (
                              <span className="errorMsg">
                                {dueDateError}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-4 mb-3">
                        <label htmlFor="Priority" className="form-label">
                          Priority
                        </label>
                        <FormControl fullWidth>
                          <Select
                            onBlur={(e) => handleBlur(e, nameChange.task_id)}
                            name="priority_id"
                            value={nameChange.priority_id || ""}
                            onChange={handleInputChange}
                            IconComponent={ExpandMoreIcon}
                            displayEmpty
                            disabled={fieldsDisabled}
                            renderValue={(selectedId) => {
                              const selectedPriority =
                                PriorityNameOptions?.find(
                                  (option) => option.priority_type === "TASK"
                                )?.priority_details.find(
                                  (priority) =>
                                    priority.priority_id === selectedId
                                );

                              return (
                                <span
                                  style={{
                                    color:
                                      selectedPriority?.priority_colour ||
                                      "inherit",
                                  }}
                                >
                                  {selectedPriority?.priority_name ||
                                    "Select Priority"}
                                </span>
                              );
                            }}
                          >
                            {PriorityNameOptions?.find(
                              (option) => option.priority_type === "TASK"
                            )?.priority_details.map((priority) => (
                              <MenuItem
                                key={priority?.priority_id}
                                value={priority?.priority_id}
                                sx={{ color: priority.priority_colour }}
                              >
                                {priority?.priority_name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="estimated_hours" className="form-label">
                          Estimated Hours
                        </label>
                        <TextField
                          type="number"
                          onBlur={(e) => handleBlur(e, nameChange.task_id)}
                          id="estimated_hours"
                          name="estimated_hours"
                          placeholder="Estimated Hours"
                          className="form-control"
                          displayEmpty
                          onChange={(event) => {
                            allowPositiveDecimals(event);
                            handleInputChange(event);
                          }}
                          value={nameChange.estimated_hours}
                          disabled={fieldsDisabled}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="consumed_hours" className="form-label">
                          Consumed Hours
                        </label>
                        <TextField
                          type="number"
                          onBlur={(e) => handleBlur(e, nameChange.task_id)}
                          id="consumed_hours"
                          name="consumed_hours"
                          placeholder="Consumed Hours"
                          className="form-control"
                          onChange={(event) => {
                            // preventNegativeValues(event);
                            handleInputChange(event);
                          }}
                          displayEmpty
                          // value={nameChange.consumed_hours}
                          value={calculatedConsumedHours}  // quick response for log hours in task details 
                          // disabled={
                          //   !["ADMIN", "MANAGER"].includes(login_user_role) && // ✅ Allow Admin & Manager
                          //   selectedUser !== login_user_id &&
                          //   task_view?.owner !== name
                          // }
                          disabled
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="Priority" className="form-label">
                          Billing Type
                        </label>
                        <FormControl fullWidth>
                          <Select
                            onBlur={(e) => handleBlur(e, nameChange.task_id)}
                            name="billing_type"
                            value={nameChange.billing_type || ""}
                            onChange={handleInputChange}
                            IconComponent={ExpandMoreIcon}
                            displayEmpty
                            disabled={fieldsDisabled}
                            defaultValue={nameChange.billing_type}
                          >
                            <MenuItem value="BILLABLE">BILLABLE</MenuItem>
                            <MenuItem value="NON-BILLABLE">
                              NON-BILLABLE
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="Priority" className="form-label">
                          Task Remainder
                        </label>
                        <TaskReminderPopup
                          id={id}
                          remainderList={task_view?.reminder}
                          refetch={refetch}
                          disabled={fieldsDisabled}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="Priority" className="form-label">
                          Task Recurrence
                        </label>
                        <TaskRecurrence
                          id={id}
                          recurrenceList={task_view?.recurring_task}
                          refetch={refetch}
                          disabled={fieldsDisabled}
                        />
                      </div>
                      {/* <TaskRemainderPopup /> */}
                      <div className="col-md-12 pb-3">
                        <label htmlFor="description" className="form-label">
                          Task Description
                        </label>
                        <TextareaAutosize
                          name="description"
                          onBlur={(e) => handleBlur(e, nameChange.task_id)}
                          minRows={4}
                          maxRows={6}
                          onChange={handleInputChange}
                          value={nameChange.description}
                          placeholder="Enter description"
                          className="textAreaField"
                          disabled={fieldsDisabled}
                        />
                      </div>
                    </div>
                    {/* ))} */}
                  </form>
                </LocalizationProvider>
                {/* 
              <SubTaskTabs
                taskid={id}
                selectedUser={selectedUser}
                login_user_name={name}
                login_user_id={login_user_id}
                login_user_role={login_user_role}
                owners={task_view?.owners || []}
                comment_count={tasksDetail.comment_count}
                document_count={tasksDetail.document_count}
              /> */}
                {/* {istaskDetail} */}
                {istaskDetail && (
                  <SubTaskTabs
                    taskid={id}
                    selectedUser={selectedUser}
                    login_user_name={name}
                    login_user_id={login_user_id}
                    login_user_role={login_user_role}
                    owners={task_view?.owners || []}
                    comment_count={tasksDetail.comment_count}
                    // logHours={tasksDetail.total_log_hours}
                    logHours={calculatedTotalLogHours}
                    document_count={tasksDetail.document_count}
                    refetch={refetch}
                  />
                )}
                {isMilestoneDetail && (
                  <MilestoneTasklistDetailTabs
                    taskid={id}
                    selectedUser={selectedUser}
                    login_user_name={name}
                    login_user_id={login_user_id}
                    login_user_role={login_user_role}
                    // logHours={tasksDetail.total_log_hours}
                    logHours={calculatedTotalLogHours}
                    owners={task_view?.owners || []}
                    comment_count={tasksDetail.comment_count}
                    document_count={tasksDetail.document_count}
                    refetch={refetch}
                  />
                )}
              </div>

              <div className="col-md-3 p-3 border rounded">
                {istaskDetail && (
                  <div className="d-flex my-3 justify-content-between ">
                    <button
                      onClick={handlePrevTaskNav}
                      className="nextPrevBtn"
                      disabled={currentIndex <= 0}
                    >
                      <ArrowBack />
                    </button>
                    <button
                      onClick={handleNextTaskNav}
                      className="nextPrevBtn"
                      disabled={currentIndex >= allTasks.length - 1}
                    >
                      <ArrowForward />
                    </button>
                  </div>
                )}

                <div
                  className="slider-container p-0"
                  style={{ maxHeight: "900px", overflow: "hidden" }}
                >
                  <div className="d-flex align-items-end justify-content-between">
                    <h4 className="mb-1">All Open Tasks</h4>

                    <div className="arrows d-flex">
                      <div className="arrows d-flex">
                        <button
                          className="slick-prev"
                          onClick={handlePrevClick}
                        >
                          <FaChevronUp />
                        </button>
                        <button
                          className="slick-next"
                          onClick={handleNextClick}
                        >
                          <FaChevronDown />
                        </button>
                      </div>
                    </div>
                  </div>
                  {istaskDetail && (
                    <Slider {...settings} ref={sliderRef}>
                      {allTasks.map((task, index) => {
                        const ownerNames = Array.isArray(task.owners)
                          ? task.owners.map((owner) => owner.name ? owner.name.split(" ")[0] : "")
                          : []; // Extract first names safely
                        const ownerDisplay = ownerNames[0] || "Unassigned";

                        return (
                          <div
                            key={index}
                            className={`border rounded p-3 mb-2 box ${tasksDetail?.task_id === task.task_id
                                ? "active"
                                : ""
                              }`}
                            onClick={() => handleBoxClick(task.task_id)}
                            style={{ display: "block" }} // Ensure visibility
                          >
                            <div className="d-flex align-items-center pb-3">
                              <div
                                className="pe-2 fw-bold truncated-text"
                                title={task.title}
                              >
                                {task.title}
                              </div>
                              {/* <div className="taskHighlight"></div> */}
                            </div>
                            <div className="d-flex align-items-center">
                              <label className="text-rgba-gray text-nowrap pe-2 d-flex align-items-center">
                                Owner
                              </label>
                              <label>{ownerDisplay}</label>
                            </div>
                          </div>
                        );
                      })}
                    </Slider>
                  )}

                  {isMilestoneDetail && (
                    <Slider {...settings} ref={sliderRef}>
                      {subtasklist?.map((task) => (
                        <div
                          key={task.task_id}
                          className={`border rounded p-3 mb-2 box ${tasksDetail?.task_id === task.task_id
                            ? "active"
                            : ""
                            }`}
                          onClick={() => handleBoxClick(task.task_id)}
                        >
                          <div className="d-flex align-items-center pb-3">
                            <div
                              className="pe-2 fw-bold truncated-text"
                              title={task.title}
                            >
                              {task.title}
                            </div>
                            <div className="taskHighlight"></div>
                          </div>
                          <div className="d-flex align-items-center">
                            <label className="text-rgba-gray text-nowrap pe-2 d-flex align-items-center">
                              Owner
                            </label>
                            <label>{task.owners[0]?.name}</label>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
